module.exports = "/_next/static/images/42b0fda3481d431da063b59ad439a77e-folha-de-sp-logo.png";